/**
 * Merchant Feed price formatter.
 */
module.exports.merchantPriceFormatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'decimal',
  minimumFractionDigits: 2
})